export default "/exhibition";
